import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

function ConfirmationModal(props) {
  const dispatch = useDispatch();
  const event = props.function;
  const btnClass = props.btnClass;
  const iconClass = props.iconClass;
  const action = props.action;
  const argument = props.argument;
  const title = props.title;
  const message = props.message;
  const text = props.text;
  const containerClass = props.containerClass;
  const successMessage = props.successMessage ?? 'Guardar';
  const cancelMessage = props.cancelMessage ?? 'Cancelar';
  const btnSuccessState = props.btnSuccessState ?? 'success';
  const btnCancelState = props.btnCancelState ?? 'danger';
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <div
      className={containerClass ? containerClass : ''}
      style={{ display: 'inline-block' }}
    >
      <Button className={btnClass} onClick={toggle}>
        {text}
        {iconClass ? <i className={iconClass}></i> : ''}
      </Button>
      <Modal isOpen={modal} fade={false} toggle={toggle}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="desc">{message}</Label>
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button color={btnSuccessState} onClick={() => action(argument)}>
            {successMessage}
          </Button>
          <Button color={btnCancelState} onClick={toggle}>
            {cancelMessage}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ConfirmationModal;
